import getContentGraphParams from '@gameday/core/datasources/helpers/getContentGraphParams';
import getQueryParamOverride from '@gameday/utils/getQueryParamOverride';

const moreCoverageDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gamePk
            },
            config: {
                env,
                locale = 'en-US',
                context: {
                    gameContext = 'mlb'
                } = {},
                useContentApi = false
            }
        } = state;
        const useContentApiOverride = getQueryParamOverride('useContentApi');
        if (useContentApiOverride ?? useContentApi) {
            return componentDataEngine.fetchAndStore('cmsdapi', { gamePk, locale });
        }

        return componentDataEngine.fetchAndStore('contentGraph', getContentGraphParams({ gamePk, locale, gameContext, env }));
    };
};

export default moreCoverageDataRequestAction;
